const IntegrationSyncStatuses = {
  NO_SYNC: 0,
  SYNCING: 1,
  SYNCED: 2,
};

export default IntegrationSyncStatuses;
